// Lightweight Suspense fallback shown while a code-split route chunk loads.
// Centered skeleton consistent with the rest of the app (see .skeleton in
// styles/global.css).
export function RouteFallback() {
  return (
    <div
      style={{
        display: "grid",
        placeItems: "center",
        minHeight: "60vh",
        width: "100%",
        background: "var(--bg-primary)",
      }}
      aria-busy="true"
      aria-live="polite"
    >
      <div className="skeleton" style={{ width: 120, height: 24 }} />
    </div>
  );
}
